<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <header class="header">
    <div class="header-top"></div>
    <nav class="navbar">
      <div class="nav-container">
        <!-- Logo -->
        <div
          class="logo-section"
          @click="$router.push('/Home')"
          style="cursor: pointer"
        >
          <img src="@/assets/images/Home_logo2.svg" alt="GodGreek Logo" />
        </div>

        <!-- Hamburger Icon (Mobile only) -->
        <div class="hamburger" @click="toggleMobileMenu">
          <i v-if="!isMobileMenuOpen" class="pi pi-bars"></i>
          <i v-else class="pi pi-times"></i>
        </div>

        <!-- Desktop Menu -->
        <ul class="nav-menu desktop-menu">
          <li class="nav-item">
            <!-- <a @click="$router.push('/Home#home')" class="nav-link">Home111111111</a> -->
            <a
              href="javascript:void(0)"
              class="nav-link"
              @click="scrollToSection('home')"
              >Home</a
            >
          </li>
          <li class="nav-item">
            <!-- <a @click="$router.push('/Home#about')" class="nav-link">About</a>
                -->
            <a
              href="javascript:void(0)"
              class="nav-link"
              @click="scrollToSection('about')"
              >About</a
            >
          </li>
          <li class="nav-item">
            <!-- <a @click="$router.push('/Home#games')" class="nav-link">Games</a> -->
            <a
              href="javascript:void(0)"
              class="nav-link"
              @click="scrollToSection('games')"
              >Games</a
            >
          </li>
          <!-- <li class="nav-item" v-if="token">
            <a class="nav-link" @click="onClickMyBooking">My Booking</a>
          </li>
          <li class="nav-item" v-if="token">
            <a class="nav-link" @click="onClickMyPlan">My Plan</a>
          </li> -->
          <li class="nav-item">
            <a class="nav-link" @click="onClickMembership">Membership</a>
          </li>
        </ul>

        <!-- ✅ Profile (Desktop) -->
        <div class="profile-section desktop-menu">
          <div v-if="token" class="points-display">
            <span class="username mr-2">Points</span><br />
            <span class="username mr-2">{{ points || "0" }}</span>
          </div>
          <!-- <span v-if="token" class="username mr-2">{{ user }}</span>
          <i v-if="token" class="pi pi-sign-out" @click="logout"></i> -->
          <div
            v-if="token"
            class="profile-dropdown"
            @click="toggleProfileDropdown"
          >
            <span class="username mr-2">{{ user }}</span>
            <i class="pi pi-chevron-down"></i>

            <!-- Dropdown Menu -->
            <ul v-if="isProfileDropdownOpen" class="dropdown-menu">
              <li @click="onClickMyAccount">My Account</li>
              <li @click="logout">Logout</li>
            </ul>
          </div>
          <div v-else>
            <button @click="login" class="nav-btn login-btn">Login</button>
          </div>
        </div>
      </div>

      <!-- ✅ Mobile Dropdown Menu -->
      <transition name="slide">
        <div v-if="isMobileMenuOpen" class="mobile-menu">
          <ul>
            <li>
              <a
                href="javascript:void(0)"
                class="nav-link"
                @click="
                  scrollToSection('home');
                  closeMobileMenu();
                "
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                class="nav-link"
                @click="
                  scrollToSection('about');
                  closeMobileMenu();
                "
              >
                About
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                class="nav-link"
                @click="
                  scrollToSection('games');
                  closeMobileMenu();
                "
              >
                Games
              </a>
            </li>
            <!-- <li v-if="token">
              <a
                class="nav-link"
                @click="
                  () => {
                    onClickMyBooking();
                    closeMobileMenu();
                  }
                "
              >
                MyBooking
              </a>
            </li> -->
            <!-- <li v-if="token">
              <a
                class="nav-link"
                @click="
                  () => {
                    onClickMyPlan();
                    closeMobileMenu();
                  }
                "
              >
                MyPlan
              </a>
            </li> -->
            <li>
              <a
                class="nav-link"
                @click="
                  () => {
                    onClickMembership();
                    closeMobileMenu();
                  }
                "
              >
                Membership
              </a>
            </li>
            <li>
              <!-- <a
                class="nav-link"
                @click="
                  logout;
                  closeMobileMenu();
                "
                >Logout</a
              > -->
              <span v-if="token" class="username mr-2"
                >Points :- {{ points || "0" }}</span
              >
              <!-- <span v-if="token" class="username mr-2">{{ user }}</span>
              <i
                v-if="token"
                class="out pi pi-sign-out"
                @click="
                  () => {
                    logout();
                    closeMobileMenu();
                  }
                "
              ></i> -->
              <!-- ✅ Mobile Profile Dropdown -->
              <div v-if="token" class="profile-dropdown-mobile">
                <span
                  class="username mr-2 user-name-btn"
                  @click="toggleProfileDropdown"
                >
                  {{ user }} <i class="pi pi-chevron-down"></i>
                </span>

                <!-- Dropdown -->
                <ul v-if="isProfileDropdownOpen" class="dropdown-menu">
                  <li
                    @click="
                      () => {
                        onClickMyAccount();
                        closeMobileMenu();
                      }
                    "
                  >
                    My Account
                  </li>
                  <li
                    @click="
                      () => {
                        logout();
                        closeMobileMenu();
                      }
                    "
                  >
                    Logout
                  </li>
                </ul>
              </div>

              <div v-else>
                <button
                  @click="
                    () => {
                      login();
                      closeMobileMenu();
                    }
                  "
                  class="nav-btn login-btn"
                >
                  Login
                </button>
              </div>
            </li>
          </ul>
        </div>
      </transition>
    </nav>
  </header>
</template>

<script>
import APIService from "@/services/api.service";
export default {
  data() {
    return {
      isMobileMenuOpen: false,
      isProfileDropdownOpen: false,
      // user: this.$store.state.userInfo.firstname,
      user: "",
      points: "",
      token: this.$store.state.userToken,
      userId: this.$store.state.userInfo.id,
    };
  },
  created() {
    this.getReward(this.userId);
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // toggleProfileDropdown() {
    //   this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
    // },
    handleResize() {
      if (window.innerWidth > 768 && this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false; // auto-close on desktop
      }
    },
    toggleProfileDropdown() {
      this.isProfileDropdownOpen = !this.isProfileDropdownOpen;

      if (this.isProfileDropdownOpen) {
        document.addEventListener("click", this.handleClickOutside);
      } else {
        document.removeEventListener("click", this.handleClickOutside);
      }
    },
    // handleClickOutside(event) {
    //   const dropdown = this.$el.querySelector(".profile-dropdown");
    //   if (dropdown && !dropdown.contains(event.target)) {
    //     this.isProfileDropdownOpen = false;
    //     document.removeEventListener("click", this.handleClickOutside);
    //   }
    // },
    handleClickOutside(event) {
      const desktopDropdown = this.$el.querySelector(".profile-dropdown");
      const mobileDropdown = this.$el.querySelector(".profile-dropdown-mobile");

      if (
        (desktopDropdown && desktopDropdown.contains(event.target)) ||
        (mobileDropdown && mobileDropdown.contains(event.target))
      ) {
        return; // click inside dropdown → do nothing
      }

      this.isProfileDropdownOpen = false;
      document.removeEventListener("click", this.handleClickOutside);
    },
    onClickMyAccount() {
      this.$router.push({ name: "MyAccount" });
      this.isProfileDropdownOpen = false;
    },
    async getReward(userId) {
      try {
        const response = await APIService.get(`user/get/${userId}`);
        const user = response.data.data.points;
        this.points = user || "0";
        this.user = response.data.data.firstName;
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    },
    scrollToSection(sectionId) {
      if (this.$route.path !== "/Home") {
        this.$router.push({ path: "/Home", hash: `#${sectionId}` });
      } else {
        const el = document.getElementById(sectionId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    },
    onClickMembership() {
      this.$router.push({ name: "MembershipUser" });
    },
    // onClickMyBooking() {
    //   this.$router.push({ name: "MyBooking" });
    // },
    // onClickMyPlan() {
    //   this.$router.push({ name: "MyPlan" });
    // },
    login() {
      this.$router.push("/login");
    },
    logout() {
      localStorage.removeItem("userToken");
      this.$store.commit("setUserToken", null);
      this.$router.push("/login");
      this.isProfileDropdownOpen = false;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
  },
};
</script>

<style scoped>
.privacy-policy-page {
  background: #0e0e0e;
  color: #fff;
  font-family: "Barlow", sans-serif;
  line-height: 1.6;
}

/* Header Styles */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: black;
}

.navbar {
  padding: 15px 0;
}

.nav-container {
  /* max-width: 1280px; */
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 18px;
}

.logo-text {
  font-family: "Barlow", sans-serif;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 40px;
  align-items: center;
  margin-left: auto;
}

.username {
  font-family: "Barlow", sans-serif;
  color: #fff;
}

.nav-item {
  position: relative;
  cursor: pointer;
}

.nav-link {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.72px;
  text-transform: uppercase;
  transition: color 0.3s ease;
}

.nav-item.active .nav-link {
  color: #cd2504;
}

.nav-item.active .nav-underline {
  height: 1px;
  background: #cd2504;
  border-radius: 20px;
  margin-top: 3px;
}

.nav-link:hover {
  color: #cd2504;
}

.profile-section {
  margin-left: auto;
  position: relative;
  color: #fff;
}

.points-display {
  text-align: left; /* Or whatever fits your layout */
}

.profile-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}

.profile-btn {
  border: none;
  box-shadow: none;
}

@media (max-width: 991px) {
  .nav-container {
    padding: 0 40px;
  }

  .nav-menu {
    gap: 20px;
  }

  .nav-link {
    font-size: 14px;
  }
}

@media (max-width: 640px) {
  .nav-container {
    padding: 0 20px;
    flex-direction: row;
    height: auto;
    /* gap: 20px; */
  }

  .nav-menu {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }
}

.privacy-policy {
  /* min-height: 100vh; */
  display: flex-column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  background-color: black;
  margin-top: 90px;
}

.privacy-container {
  background-color: #14141c;
  color: #ffffff;
  padding: 35px;
  max-width: 1000px;
  margin: 0 auto;
  font-family: "Barlow", sans-serif;
  border-radius: 8px;
}

h1 {
  font-size: 2em;
  margin-bottom: 10px;
  text-align: center;
}

.privacy-list {
  list-style-type: none;
  padding-left: 0;
  counter-reset: section;
}

.privacy-list li {
  position: relative;
  margin-bottom: 20px;
  padding-left: 30px;
}

.privacy-list li::before {
  counter-increment: section;
  content: counter(section) ".";
  position: absolute;
  left: 0;
  font-size: 1.5em;
  color: #ffffff;
  min-width: 20px;
  text-align: right;
}

.sub-list {
  list-style-type: none;
  padding-left: 25px;
  counter-reset: subsection;
}

.sub-list li {
  position: relative;
  padding-left: 30px;
}

.sub-list li::before {
  counter-increment: subsection;
  content: counter(section) "." counter(subsection) " ";
  position: absolute;
  left: -10px;
  font-size: 1.2em;
  color: #ffffff;
  min-width: 30px;
  text-align: right;
}

.info-list,
.contact-list {
  list-style-type: disc;
  padding-left: 20px;
  margin-top: 10px;
}

.info-list li,
.contact-list li {
  margin-bottom: 10px;
  padding-left: 0;
  line-height: 1.5;
}

.info-list li::before,
.contact-list li::before {
  content: none;
}

h2 {
  font-size: 1.5em;
  margin-bottom: 10px;
  /* margin-left: 10px; */
}

h3 {
  font-size: 1.2em;
  margin-bottom: 5px;
}

p {
  font-size: 1em;
  line-height: 1.5;
  margin-bottom: 15px;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 80px;
}

@media (max-width: 1200px) {
  .container {
    padding: 0 40px;
  }
}

@media (max-width: 640px) {
  .container {
    padding: 0 20px;
  }
}

.contact-section {
  background-color: #14141c;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 80px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 1000px;
}

.contact-container {
  display: flex;
  max-width: 1200px;
  width: 100%;
  gap: 60px;
  align-items: flex-start;
  justify-content: space-between;
}

.contact-info {
  flex: 1;
  color: #fff;
}

.join-text {
  font-size: 12px;
  color: #e50914 !important;
  font-weight: bold;
  letter-spacing: 1px;
}

.contact-info h2 {
  font-size: 32px;
  font-weight: 900;
  margin: 20px 0 10px;
  text-transform: uppercase;
}

.contact-info p {
  font-size: 16px;
  color: #d4d5d9;
  max-width: 400px;
}

.contact-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-row input,
.form-row textarea {
  flex: 1;
  background: #450a0e;
  border: none;
  outline: none;
  padding: 14px 16px;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
}

.form-row textarea {
  min-height: 120px;
  resize: none;
}

.submit-btn {
  align-self: flex-start;
  background: #e50914 !important;
  border: none;
  padding: 12px 32px;
  border-radius: 6px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.submit-btn:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .contact-container {
    flex-direction: column;
    gap: 40px;
  }

  .form-row {
    flex-direction: column;
  }
}
.main-heading {
  font-family: "Barlow", sans-serif;
}
.info-text {
  font-family: "Barlow", sans-serif;
}
/* Hide hamburger on desktop */
.hamburger {
  display: none;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
}

/* Mobile Menu styles */
.mobile-menu {
  background: black;
  padding: 20px;
}
.mobile-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.mobile-menu li {
  margin: 15px 0;
}
.mobile-menu a {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
}
.user-name-btn {
  display: flex;
  align-items: center;
  background: red;
  width: 100px;
  padding: 10px;
  margin-top: 10px;
  border-radius: 8px;
  justify-content: space-between;
}

/* Desktop-only elements */
.desktop-menu {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Responsive rules */
@media (max-width: 768px) {
  .desktop-menu {
    display: none !important;
  }
  .hamburger {
    display: block;
  }
}

/* Slide animation */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter {
  opacity: 0;
  transform: translateY(-10px);
}
.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.nav-btn {
  padding: 10px 25px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 5px;
}
.login-btn {
  width: 150px;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 700;
  background: rgba(229, 9, 20, 0.9) !important;
  color: #fff;
  border: none !important;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Barlow", sans-serif;
}
.out {
  color: #fff;
}
/* Profile Dropdown */
.profile-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #fff;
  padding: 10px;
  background: red;
  border-radius: 8px;
}

.profile-dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #14141c;
  border: 1px solid #333;
  border-radius: 6px;
  list-style: none;
  padding: 10px 0;
  margin: 5px 0 0;
  min-width: 150px;
  z-index: 2000;
}

.profile-dropdown .dropdown-menu li {
  padding: 10px 15px;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}

.profile-dropdown .dropdown-menu li:hover {
  background: #222;
}

/* Mobile Dropdown */
.profile-dropdown-mobile .dropdown-menu {
  background: #14141c;
  border: 1px solid #333;
  border-radius: 6px;
  list-style: none;
  padding: 10px 0;
  margin: 5px 0 0;
}
.profile-dropdown-mobile .dropdown-menu li {
  padding: 10px 15px;
  color: #fff;
}
.profile-dropdown-mobile .dropdown-menu li:hover {
  background: #222;
}
</style>
